import React from 'react';
import PropTypes from 'prop-types';
import LogoLink from './LogoLink';

const AppBarChildren = (props) => {
  const {
    headerNavArray,
    hideHeader,
    pathName,
    logo,
    logoLinkAnchorClass,
    logoLinkImgClass,
    mobileClass,
    topRightButtons,
    reportButtonPress,
  } = props;

  if (hideHeader(pathName)) {
    return (
      <ul>
        <li>
          <LogoLink
            anchorClass={logoLinkAnchorClass}
            imgClass={logoLinkImgClass}
            logo={logo}
            mobileClass={mobileClass}
            reportButtonPress={reportButtonPress}
          />
        </li>
      </ul>
    );
  }
  return (
    <ul className='fs-header-logo-container'>
      {headerNavArray}
      {topRightButtons}
    </ul>
  );
};

AppBarChildren.propTypes = {
  headerNavArray: PropTypes.array,
  hideHeader: PropTypes.func,
  logoLinkAnchorClass: PropTypes.string,
  logoLinkImgClass: PropTypes.string,
  logo: PropTypes.string,
  mobileClass: PropTypes.string,
  pathName: PropTypes.string,
  reportButtonPress: PropTypes.func,
  topRightButtons: PropTypes.object,
};

export default AppBarChildren;



// WEBPACK FOOTER //
// ./modules/App/components/children/Header/children/AppBarChildren.js